import React, { useContext, useEffect } from "react";
import { Routes, Route, useNavigate } from "react-router-dom";

//Layouts
import NonAuthLayout from "../Layouts/NonAuthLayout";
import VerticalLayout from "../Layouts/index";
import AuthProtected from "./AuthProtected";

//routes
import { authProtectedRoutes, publicRoutes } from "./allRoutes";
import { IsValidRoutePermissions } from "Routes/AuthProtected";

import { isTokenNearExpiry , getToken, clearAuthData} from "helpers/jwt-token-access/auth-token-header";
import { Alert } from "reactstrap";
import { toast } from "react-toastify";

const Index = () => {

  const navigate = useNavigate();

  const filteredAuthRoutes = authProtectedRoutes.filter(
    (route) => !route.permissions || IsValidRoutePermissions(route.permissions),
  );

  const token = getToken();

 // 5mins
  const CHECK_INTERVAL = 5 * 60 * 1000;

  useEffect(() => {
    const checkTokenExpiry = () => {
      if (token && isTokenNearExpiry(token)) {

        toast.error("Your session has expired. Please login again.", {
          autoClose: 6000,
          position: toast.POSITION.TOP_LEFT
        });
        // Token is expired or near expiry - logout user
        clearAuthData();
        navigate("/login", { replace: true });
         
        console.log("Session expired. Please login again.");
      }
    };

    checkTokenExpiry();

    const intervalId = setInterval(checkTokenExpiry, CHECK_INTERVAL);

    // Clean up interval on unmount
    return () => clearInterval(intervalId);
  }, [token, navigate]);




  return (
    <React.Fragment>
      <Routes>
        <Route>
          {publicRoutes.map((route: any, idx: any) => (
            <Route
              path={route.path}
              element={<NonAuthLayout>{route.component}</NonAuthLayout>}
              key={idx}
              // exact={true}
            />
          ))}
        </Route>

        <Route>
          {authProtectedRoutes.map((route, idx) => (
            <Route
              path={route.path}
              element={
                <AuthProtected>
                  <VerticalLayout>{route.component}</VerticalLayout>
                </AuthProtected>
              }
              key={idx}
              // exact={true}
            />
          ))}
        </Route>
      </Routes>
    </React.Fragment>
  );
};

export default Index;
